export default __webpack_public_path__ + "static/media/japan.11f08db5.jpeg";